export default "__VITE_ASSET__594f3a85__"